import { useAgentHold, setArHold, useToast } from '@elva/ui';

/** Holding Accounts receivable (amendment 28 §3 → specs 36 + 37, shared store). */
export function useArHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('ar');
  const { toast } = useToast();
  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setArHold(next);
      toast({
        title: next ? 'Accounts receivable is on hold' : 'Accounts receivable is working again — 14 held messages go at their next window',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
